<script>
import Axios from "axios";
import ComponentBaseVue from "./ComponentBase.vue";

export default {
    extends: ComponentBaseVue,
    data() {
        return {
            apiUrl: undefined,
            debugFlag: false,
        };
    },
    methods: {
        apiGet(url = undefined) {
            return this.apiFormatOutput(Axios.get(url ?? this.apiUrl));
        },
        apiPost(data = {}) {
            return this.apiFormatOutput(Axios.post(this.apiUrl, data));
        },
        apiUpdate(data = {}, method = "patch") {
            if (method === "post")
                return this.apiFormatOutput(
                    this.apiPost(Object.assign({}, data, {_method: "patch"}))
                );
            if (method === "patch" || method === "put")
                return this.apiFormatOutput(Axios[method](this.apiUrl, data));
        },
        apiDelete(data = {}) {
            return this.apiFormatOutput(Axios.delete(this.apiUrl, {data}));
        },
        apiFormatOutput(promise) {
            if (promise instanceof Promise) {
                return new Promise((resolve, reject) => {
                    promise
                        .then((success_response) => {
                            if (this.debugFlag) console.log([success_response]);
                            resolve(success_response.data);
                        })
                        .catch((error) => {
                            if (this.debugFlag) console.log([error]);
                            if (error.isAxiosError) reject(error.response.data);
                            else reject(this.apiHandleError(error));
                        });
                });
            } else {
                return promise;
            }
        },
        apiHandleError(error) {
            if (this.debugFlag) console.log([error]);
            return error;
        }
    }
};
</script>
